import React, { useContext, useEffect, useState } from "react";

import {
    ConfigContext,
    ProjectContext,
    TranslationContext,
    VersionContext
} from "@swegon/sds-core";

import { OutdatedWrapper, OutdatedLink } from "./OutdatedNotice.styles";
import AhuApi from "../api/ahuApi";

const MODULES_TO_CHECK = ["application", "ahuData", "climateSettings"];

export const OutdatedNotice = () => {
    const {
        getOutdatedModules,
        isLatestUpstreamApplication,
        upstreamVersions,
        versions
    } = useContext(VersionContext);
    const { project } = useContext(ProjectContext);
    const { config } = useContext(ConfigContext);
    const { l } = useContext(TranslationContext);

    const [latestVersions, setLatestVersions] = useState(upstreamVersions);
    const [currentVersions, setCurrentVersions] = useState(versions);

    useEffect(() => {
        const ahuApi = new AhuApi(config.ahu_base, config);
        ahuApi.getVersion().then(version => {
            setLatestVersions({
                ...upstreamVersions,
                application: version,
                climateSettings: version
            });
        });
    }, [config, upstreamVersions]);

    useEffect(() => {
        if (!project || !project.VersionInfo) {
            return;
        }
        setCurrentVersions({
            ...versions,
            application: project.VersionInfo.application,
            climateSettings: project.VersionInfo.climateSettings
        });
    }, [versions, project]);

    if (!project || !project.VersionInfo) {
        return null;
    }

    if (
        config.environment === "DEV" ||
        isLatestUpstreamApplication(currentVersions, latestVersions, MODULES_TO_CHECK, project)
    ) {
        return null;
    }

    const outdatedUpstreamModules = getOutdatedModules(latestVersions, project, MODULES_TO_CHECK);
    const outdatedModules = getOutdatedModules(currentVersions, project, MODULES_TO_CHECK);

    let outdatedInfo = null;

    const goToLatestUrl = config.sds_url + "ahu/" + window.location.search + window.location.hash;

    if (outdatedModules.length) {
        outdatedInfo = <span>{`${outdatedModules.length} ${l("texts.outdatedModules")}`}</span>;
    } else if (outdatedUpstreamModules.length) {
        outdatedInfo = (
            <span>
                {l("texts.notRunningLatestApplication")}
                <OutdatedLink href={goToLatestUrl}>{l("buttons.goToLatest")}</OutdatedLink>
            </span>
        );
    }

    return (
        <OutdatedWrapper>
            <span>{`${l("common.version")}: ${project.VersionInfo.application}`}</span>

            {outdatedInfo}
        </OutdatedWrapper>
    );
};

export default OutdatedNotice;
